import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  VEHICLE_VALUATION_PRICE_ADJUSTMENT_API_PATH,
  VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE,
  type VehicleValuationPriceAdjustmentCreateBody,
  type VehicleValuationPriceAdjustmentCreateResponse,
} from "./vehicle-valuation-price-adjustment.types";

export function useVehicleValuationPriceAdjustmentCreateMutation() {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationPriceAdjustmentCreateResponse, Error, VehicleValuationPriceAdjustmentCreateBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.post<VehicleValuationPriceAdjustmentCreateResponse>(
        VEHICLE_VALUATION_PRICE_ADJUSTMENT_API_PATH,
        body,
      );

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE],
      });
    },
  });
}
